import React from "react";
import { DefaultDataTable } from "../../../components/dataTable/DefaultDataTable";

export const BotaoDinamicoList = props => <DefaultDataTable data={props} />;
